import NoData from 'components/common/NoData/noData';
import { usePhasePerformanceStore } from 'store/phasePerformance.store';
import React from 'react';
import { Link } from 'react-router-dom';
import { useBasePath } from 'hooks/useBasePath';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { PhasePerformanceChart } from 'components/widgets/phasePerformanceChart/phasePerformanceChart';
import { PhasePerformanceBreakdown } from 'components/widgets/phasePerformanceBreakdown/phasePerformanceBreakdown';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const PhasePerformance = () => {
    const basePath = useBasePath();
    const template = usePhasePerformanceStore((store) => store.template);
    const linkToManageTemplates = AppRoutes.buildPath(basePath, portfolioConfig.phasePerformanceManage.link);

    return template ? (
        <>
            <PhasePerformanceChart />
            <PhasePerformanceBreakdown />
        </>
    ) : (
        <NoData>
            No templates defined yet. Click <Link to={linkToManageTemplates}>Manage Templates</Link> above to set it up.
        </NoData>
    );
};
